(function() {
'use strict';

/*
 * Directive for newsletter signup
 */
angular
    .module('TR')
    .directive('newsletterSignUp', function(authService, $timeout, $location, analytics) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'partials/home/directivetemplate?type=newslettersignup',
            controllerAs: 'nsu',
            bindToController: {
                allowUnsubscribe: '='
            },
            controller($scope) {
                this.email = null;
                this.success = false;
                this.error = false;

                this.change = () => {
                    this.success = false;
                };

                this.openOptOut = e => {
                    if (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    this.showOptOut = true;
                    analytics.track('mixpanel', 'GDPRUnsubscribe');
                };

                this.closeOptOut = e => {
                    if (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    this.showOptOut = false;
                };

                this.submit = email => {
                    const data = {
                        Email: email,
                        ContextTag: 'Source:Website-Newsletter',
                        Source: 'TravelRepublic',
                        SignupReason: 'Newsletter Signup Header'
                    };

                    authService
                        .registerForNewsletter(data)
                        .success(() => {
                            $scope.$emit('newsletterSignUp');
                            this.success = true;
                            this.error = false;
                            if (TRPCONFIG.Domain.TrackNewsletterSignup) {
                                const page = $location.path();
                                analytics.trackEvent({
                                    category: 'newsletterSignup',
                                    action: 'signedUp',
                                    label: page,
                                    dimension9: 'newsletterSignup'
                                });
                            }
                            $timeout(() => {
                                    this.success = false;
                                }, 2000);
                        })
                        .error(() => {
                            this.success = false;
                            this.error = true;
                        });
                };
            }
        };
    });
})();
